import toolsClient from "@/api/toolsClient";
import { config } from "/app.config";

const list = async (id, type = "accounts") => {
  const { data } = await toolsClient.get(`/${type}/${id}/getSubscriptions/`);

  return data;
};

const get = async (id, priceId, type = "accounts") => {
  const { data } = await toolsClient.get(
    `/${type}/${id}/getSubscription/${priceId}`
  );

  return data;
};

const create = async (id, payload, type = "accounts") => {
  const { data } = await toolsClient.post(
    `/${type}/${id}/createSubscription`,
    payload
  );

  return data;
};

const cancel = async (id, priceId, type = "accounts") => {
  const { data } = await toolsClient.delete(
    `/${type}/${id}/cancelSubscription/${priceId}`
  );

  return data;
};

// includeCampaignClaim adds the campaign discount to the main plan price the account already pays for,
// so the plans page can offer it as a claim. Only sent once that claim can be made (the plan-change API is
// on): through the portal the discount couldn't be claimed. The backend ignores it on Aiir/Nistar.
export const getAccountPlans = async (id, useCurrencyOptions = false, requestConfig = {}) => {
  const { data } = await toolsClient.get(`/accounts/${id}/plansDiscounts`, {
    ...requestConfig,
    params: {
      useCurrencyOptions: useCurrencyOptions || null,
      includeCampaignClaim: config.isPlanChangeApiEnabled || null,
    },
  });

  return data;
};

export const getAccountPlansFeatures = async (id) => {
  const { data } = await toolsClient.get(`/accounts/${id}/planFeatures`);

  return data;
};

export const canUpdateSubscription = async (id, priceId, quantity, promoCode) => {
  const { data } = await toolsClient.get(
    `/accounts/${id}/canUpdateSubscription?updatePriceId=${priceId}`
      + (quantity ? `&updateQuantity=${quantity}` : '')
      + (promoCode ? `&promoCode=${promoCode}` : '')
  );

  return data;
};

export const addAccountSubscriptionPromoCode = async (id, subscriptionId, promoCode) => {
  const { data } = await toolsClient.post(
    `/accounts/${id}/subscription/${subscriptionId}/promoCode/${promoCode}`
  );

  return data;
};

export const pauseAccountSubscription = async (id, subscriptionId, months) => {
  const { data } = await toolsClient.post(
    `/accounts/${id}/subscription/${subscriptionId}/pause`,
    { months }
  );

  return data;
};

export const createAccountSubscriptionMultiItem = async (id, payload) => {
  const { data } = await toolsClient.post(
    `/accounts/${id}/createSubscription/multiItem`,
    payload
  );

  return data;
};

export const getCheckoutSessionStatus = async (id, sessionId) => {
  const { data } = await toolsClient.get(
    `/accounts/${id}/checkout/session/${sessionId}/status`
  );

  return data;
};

export const previewSubscriptionUpdate = async (id, params) => {
  const { data } = await toolsClient.get(
    `/accounts/${id}/previewSubscriptionUpdate/multiItem`,
    { params }
  );

  return data;
};

export const updateAccountSubscriptionMultiItem = async (id, payload) => {
  const { data } = await toolsClient.put(
    `/accounts/${id}/updateSubscription/multiItem`,
    payload
  );

  return data;
};

export default {
  list,
  get,
  create,
  cancel,
  getAccountPlans,
  getAccountPlansFeatures,
  canUpdateSubscription,
  addAccountSubscriptionPromoCode,
  pauseAccountSubscription,
  createAccountSubscriptionMultiItem,
  getCheckoutSessionStatus,
  previewSubscriptionUpdate,
  updateAccountSubscriptionMultiItem,
};
